module.exports = __webpack_public_path__ + "img/图片17.81d76476.png";